import React, { useState } from 'react';
import useResponsiveLayout from '../hooks/useResponsiveLayout';

interface ResponsiveTopbarProps {
    onToggleConfigDrawer: () => void;
    onToggleDownloadDrawer: () => void;
}

const ResponsiveTopbar: React.FC<ResponsiveTopbarProps> = ({
    onToggleConfigDrawer,
    onToggleDownloadDrawer
}) => {
    const { isCompactLayout } = useResponsiveLayout();

    // Only show on compact layouts (tablet and mobile)
    if (!isCompactLayout) {
        return null;
    }

    return (
        <header className="workspace__topbar">
            <div className="workspace__topbar-content">
                <button
                    className="workspace__topbar-btn workspace__topbar-btn--primary"
                    onClick={onToggleConfigDrawer}
                    aria-label="Toggle configuration menu"
                >
                    <svg
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    >
                        <path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z" />
                        <polyline points="9,22 9,12 15,12 15,22" />
                    </svg>
                    <span>Configuration</span>
                </button>

                <button
                    className="workspace__topbar-btn workspace__topbar-btn--secondary"
                    onClick={onToggleDownloadDrawer}
                    aria-label="Toggle account menu"
                >
                    <svg
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    >
                        <circle cx="12" cy="8" r="4" />
                        <path d="M4 20c0-3.3 3.1-6 8-6s8 2.7 8 6" />
                    </svg>
                    <span>Account</span>
                </button>
            </div>
        </header>
    );
};

export default ResponsiveTopbar;
